import { render, staticRenderFns } from "./RecordCool.vue?vue&type=template&id=161cc976&scoped=true"
import script from "./RecordCool.vue?vue&type=script&lang=js"
export * from "./RecordCool.vue?vue&type=script&lang=js"
import style0 from "./RecordCool.vue?vue&type=style&index=0&id=161cc976&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_css-loader@6.10.0_vue-template-compiler@2.7.16_webpack@5.91.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161cc976",
  null
  
)

export default component.exports